import styled from 'styled-components';

export const MapSearchContainerStyled = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	height: 100vh;
	max-height: 100%;
	overflow: hidden;
	@media (max-width: ${({ theme }) => `${theme.variables.breakPoint}px`}) {
		flex-direction: column-reverse;
	}
`;

export const ListContainerStyled = styled.div`
	position: relative;
	width: 40%;
	z-index: 8;
	background-color: white;
	display: flex;
	flex-direction: column;
	@media (max-width: ${({ theme }) => `${theme.variables.breakPoint}px`}) {
		height: 40%;
		width: 100%;
		padding-top: ${({ theme }) => `${theme.variables.padding}px`};
	}
`;

export const MapContainerStyled = styled.div`
	position: relative;
	width: 60%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	@media (max-width: ${({ theme }) => `${theme.variables.breakPoint}px`}) {
		height: 60%;
		width: 100%;
		max-height: 60%;
	}
`;

export const MobileContainerStyled = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	height: 100%;
	width: 100%;
	background: rgba(255, 255, 255, 0.5);
	z-index: 11;
	padding: 10px;
`;
